require('../../modules/es6.object.keys');
module.exports = require('../../modules/$.core').Object.keys;


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/~/core-js/library/fn/object/keys.js
 ** module id = 454
 ** module chunks = 0 11 12 14 15 16 19 20 34
 **/